// Helpers partages entre auto.renew.vue et auto.renew.modifier.vue.
// Choix de garanties a la carte, comme sur /devis/auto (onglet "A la carte").
import configAuto from '../../common/configAuto.json'

export const DUREES = [
    { value: 3,  label: '3 mois'  },
    { value: 6,  label: '6 mois'  },
    { value: 12, label: '12 mois' },
]

// RC = obligatoire legalement, verrouillee dans l'UI.
export const RC_VALUE = 'RESPONSABILITE CIVILE'

// Garanties auto a la carte, meme source que /devis/auto.
// Tierce Plafonnee est exclue (affichee disabled sur /devis/auto, jamais souscriptible).
export const GARANTIES_AUTO = configAuto.Garanties
    .filter(g => g.value !== 'TIERCE PLAFONNEE')
    .map(g => ({ value: g.value, label: g.label }))

// Garanties 2 roues, meme source que /devis/auto (idem une liste a la carte).
export const GARANTIES_MOTO = configAuto.Garanties2roues.map(g => ({
    value: g.value,
    label: g.label,
}))

// Tierce Complete / Collision masquees si vehicule > 5 ans (aligne sur /devis/auto).
export function filterGarantiesAutoByAge(age) {
    if (typeof age === 'number' && age > 5) {
        return GARANTIES_AUTO.filter(g => g.value !== 'TIERCE COMPLETE' && g.value !== 'TIERCE COLLISION')
    }
    return GARANTIES_AUTO
}

export function isValidDuree(v) {
    return DUREES.some((d) => d.value === Number(v))
}

// Retourne les garanties du vehicule qui matchent la liste connue (auto ou moto).
// RC est toujours incluse en baseline (obligatoire).
function detectSelected(vehiculeGaranties, allowed) {
    const allowedSet = new Set(allowed.map(g => g.value.toUpperCase()))
    const currentSet = new Set(
        (Array.isArray(vehiculeGaranties) ? vehiculeGaranties : []).map(g => String(g).toUpperCase())
    )
    const matched = Array.from(allowedSet).filter(v => currentSet.has(v))
    if (!matched.includes(RC_VALUE)) matched.unshift(RC_VALUE)
    return matched
}

export function detectSelectedGarantiesAuto(vehiculeGaranties) {
    return detectSelected(vehiculeGaranties, GARANTIES_AUTO)
}

export function detectSelectedGarantiesMoto(vehiculeGaranties) {
    return detectSelected(vehiculeGaranties, GARANTIES_MOTO)
}
